// src/services/accessGroupApi.js
import { apiClient } from "../utils/apiClient";

/**
 * Listeleme
 * params: { q?: string, isActive?: ''|true|false, page?: number, pageSize?: number }
 */
export async function listAccessGroups(params = {}) {
    const { q, isActive, page = 1, pageSize = 50 } = params;
    const qs = new URLSearchParams();
    if (q && q.trim()) qs.append("q", q.trim());
    if (isActive !== "" && isActive !== undefined && isActive !== null) {
        qs.append("isActive", String(isActive));
    }
    qs.append("page", String(page));
    qs.append("pageSize", String(pageSize));
    const endpoint = qs.toString()
        ? `access-groups?${qs.toString()}`
        : "access-groups";
    return await apiClient(endpoint, { method: "GET" });
}

/** Detay */
export async function getAccessGroup(id) {
    return await apiClient(`access-groups/${id}`, { method: "GET" });
}

/** Oluştur */
export async function createAccessGroup(payload) {
    // payload: { name, description?, isActive, defaultEffect?, ... }
    return await apiClient("access-groups", { method: "POST", body: payload });
}

/** Güncelle (kısmi) */
export async function updateAccessGroup(id, payload) {
    return await apiClient(`access-groups/${id}`, { method: "PUT", body: payload });
}

/** Sil (varsayılan soft; hard=true ile fizikî) */
export async function deleteAccessGroup(id, opts = {}) {
    const { hard = false } = opts;
    const endpoint = hard ? `access-groups/${id}?hard=true` : `access-groups/${id}`;
    return await apiClient(endpoint, { method: "DELETE" });
}

/** Scope kaydet (ALLOWED/YASAKLI → effect 1/0) */
export async function saveAccessGroupScopes(groupId, scopes) {
    // DİKKAT: apiClient bir fonksiyon; method/ body ile çağır.
    // Ayrıca base URL zaten /api ile başlıyor; burada /api yazma.
    return await apiClient(`access-groups/${groupId}/scopes`, {
        method: "PUT",
        body: scopes,
    });
}

/** Cihaz arama (Ad/IP döndürür, value = ID) */
export async function lookupDevices(q = "") {
    const qs = new URLSearchParams();
    if (q && q.trim()) qs.set("q", q.trim());
    return await apiClient(
        `access-groups/device-lookup${qs.toString() ? "?" + qs.toString() : ""}`,
        { method: "GET" }
    );
}
